<template lang="pug">
  v-dialog(v-model='dialog' persistent max-width='30%' )
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.whiteLabel') }}
        v-spacer
        v-btn(icon @click='close')
          v-icon close
      v-card-text
        v-textarea(rows="1" v-model="organization.whiteLabel")
        v-card-actions
          v-spacer
          v-btn(color="info" flat @click='close') Close
          v-btn(color="info" @click='save') Save
</template>

<script>

export default {
  props: {
    createDialog: {
      default: false
    },
    whiteLabel: {
      type: String,
      default: null
    }
  },
  name: "update-WhiteLabel",
  data() {
    return {
      imageDialog: "",
      dialog: false,
      organization: {
        whiteLabel: null
      }
    };
  },
  async created() {
    await this.setWhitelabel() 
  },
  watch: {
    createDialog(val) {
      this.dialog = val;
    }
  },
  methods: {
    setWhitelabel() {
      this.organization.whiteLabel = this.whiteLabel
    },
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("update", this.organization.whiteLabel)
      this.close()
    }
  }
};
</script>
